import template from './leave_taken_breakdown_by_leave_entry_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class LeaveTakenBreakdownByLeaveEntryHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class  LeaveTakenBreakdownByLeaveEntryHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new LeaveTakenBreakdownByLeaveEntryHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'LeaveTakenBreakdownByLeaveEntryHelp',
	dialog_class: LeaveTakenBreakdownByLeaveEntryHelpPage,
	template: template,
	template_filename: 'translation/dialogs/leave_taken_breakdown_by_leave_entry_help',
	provider: 'ps'
};
